import { render, staticRenderFns } from "./OldWoononOrderShow.vue?vue&type=template&id=3e4d8ce0"
import script from "./OldWoononOrderShow.vue?vue&type=script&lang=ts"
export * from "./OldWoononOrderShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports